/**
 * Cuota de tráfico del servidor rentado — la otra mitad de lo que cuesta
 * operar AROC.
 *
 * `disponible: false` NO es un error: es lo que responde el backend mientras
 * el colector no tenga testigo de la API del proveedor. La pantalla tiene que
 * decirlo con todas sus letras; pintar ceros se leería como "no hemos gastado
 * nada", que es distinto de "no hemos medido".
 */
import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";

export interface InfraTrafficDia {
  dia: string;
  salida_bytes: number;
  entrada_bytes: number;
}

export interface InfraTrafficResponse {
  disponible: boolean;
  medido_en: string | null;
  proveedor: string | null;
  servidor: string | null;
  ubicacion: string | null;
  tipo_servidor: string | null;
  salida_bytes: number | null;
  entrada_bytes: number | null;
  incluido_bytes: number | null;
  porcentaje_cuota: number | null;
  proyeccion_salida_bytes: number | null;
  excedente_bytes: number | null;
  excedente_proyectado_bytes: number | null;
  /** null (no cero) cuando no se conoce la tarifa del proveedor. */
  costo_excedente: number | null;
  costo_excedente_proyectado: number | null;
  renta_mensual: number | null;
  moneda: string | null;
  serie_diaria: InfraTrafficDia[];
}

export function useInfraTraffic() {
  return useQuery({
    queryKey: ["infra", "traffic"],
    queryFn: () => api<InfraTrafficResponse>("/api/v1/admin/infra/traffic"),
  });
}
